// extracted by mini-css-extract-plugin
module.exports = {"DisciplineEdit":"DisciplineEdit_DisciplineEdit__3pnAO"};